export const EXPERT_SERVICE_CONSENT = {
    STATUS: {
        OPT_IN: 'opt_in',
        OPT_OUT: 'opt_out',
    },
    CONTACT_METHOD: {
        CASE_CAVE: 'case_cave',
    },
};
